import { render, staticRenderFns } from "./BayFull.vue?vue&type=template&id=12ac04d9&scoped=true"
import script from "./BayFull.vue?vue&type=script&lang=js"
export * from "./BayFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ac04d9",
  null
  
)

export default component.exports